export default "__VITE_ASSET__901fb8bb__"